/**
 * Password field can have the following rules, which affect style and functionality (admin app):
 * - RequiredIf - set * after the label
 * - EnableIf - set both input field and label to disabled, when False
 * - ReadOnlyIf - set both input field and label to readOnly
 */

import { Component, ViewEncapsulation } from '@angular/core';
import { EntityPropertyBaseComponent } from '../entity-property-base/entity-property-base.component';

@Component({
  selector: 'app-entity-property-password',
  templateUrl: './entity-property-password.component.html',
  styleUrls: ['./entity-property-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EntityPropertyPasswordComponent extends EntityPropertyBaseComponent<string> {}
